import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_SURVEY_HISTORY_DELETE_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_SURVEY_HISTORY_DELETE_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_SURVEY_HISTORY_DELETE_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/user-survey-histories/${id}`,
    method: 'DELETE',
    notify: true,
  })
);

export default apiCall;
